
<template>
  <div class="VChartComponentWrap">
    <VchartComponent
      ref="VchartComponent"
      v-bind="$attrs"
      :element="element"
      :prop-value="propValue"
    />
    <div
      v-if="element.componentType==='AttendanceRate'"
      class="rate"
    >
      <div
        class="title"
        :style="`font-size: ${changeDevicePixelRatio(element.style.titleFontSize||16)}px;`"
      >{{ propValue.title }}</div>
      <div
        class="rateNum"
        :style="`font-size: ${changeDevicePixelRatio(element.style.rateFontSize||26)}px;`"
      >{{ personData.attendanceRate }}%</div>
    </div>
  </div>
</template>

<script>
import VchartComponent from './VChartComponent.vue'
import {
  personInCountChartData,
  outInChartData,
  teamData,
  workerTypeData
} from '@/api/manage'
import moment from 'moment'
import { mapState } from 'vuex'
import { queryTrendData } from '@/api/device'
import { changeDevicePixelRatio } from '@/utils/changeComponentsSizeWithScale'
import _ from 'lodash'
export default {
  components: { VchartComponent },
  props: {
    element: {
      type: Object,
      default: () => {}
    },
    propValue: {
      type: Object,
      require: true,
      default: () => {}
    },
    personData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    areaIdList: {
      type: [String, Array],
      default: ''
    }
  },
  data() {
    return {
      apiList: {
        InsidePersonCount: {
          api: personInCountChartData
        },
        InOutPersonCount: {
          api: outInChartData
        },
        AttendanceTeam: {
          api: teamData
        },
        AttendanceWokerType: {
          api: workerTypeData
        },
        EnvironmentalMonitor: {
          api: queryTrendData
        }
      }
    }
  },
  computed: {
    ...mapState({
      projectItem: (state) => state.user.projectItem,
      timeLog: (state) => state.socket.timeLog
    }),
    titleFontSize() {
      const px = Math.ceil(16 / window.devicePixelRatio)
      return px
    },
    rateFontSize() {
      const px = Math.ceil(26 / window.devicePixelRatio)
      return px
    }
  },
  watch: {
    personData() {
      this.setAttendanceRate()
    },
    timeLog(val) {
      this.throttle && this.throttle()
    }
  },
  created() {
    this.throttle = _.throttle(this.getData, 10000)
  },
  mounted() {
    this.getData()
    this.setAttendanceRate()
  },
  methods: {
    changeDevicePixelRatio,
    setAttendanceRate() {
      if (this.element.componentType === 'AttendanceRate') {
        this.propValue.option.series[0].data[0].value =
          this.personData.onJobCount - this.personData.inCount
        this.propValue.option.series[0].data[1].value = this.personData.inCount
        this.$refs.VchartComponent.render()
      }
    },
    getData() {
      const form = {
        month: moment().format('YYYY-MM'),
        pageNumber: 1,
        pageSize: 10,
        projectId: this.projectItem.projectId,
        areaIdList: this.areaIdList
      }
      this.apiList[this.element.componentType] &&
        this.apiList[this.element.componentType].api(form).then((res) => {
          if (this.element.componentType === 'InsidePersonCount') {
            this.$set(
              this.propValue.option.xAxis[0],
              'data',
              res.data.map((item) => item.hour)
            )
            this.$set(
              this.propValue.option.series[0],
              'data',
              res.data.map((item) => item.workerCount)
            )
            this.$set(
              this.propValue.option.series[1],
              'data',
              res.data.map((item) => item.managerCount)
            )
            this.$set(
              this.propValue.option.series[2],
              'data',
              res.data.map((item) => item.otherCount)
            )
          } else if (this.element.componentType === 'InOutPersonCount') {
            this.$set(
              this.propValue.option.xAxis[0],
              'data',
              res.data.map((item) => item.hour)
            )
            this.$set(
              this.propValue.option.series[0],
              'data',
              res.data.map((item) => item.inCount)
            )
            this.$set(
              this.propValue.option.series[1],
              'data',
              res.data.map((item) => item.outCount)
            )
          } else if (this.element.componentType === 'AttendanceTeam') {
            this.$set(
              this.propValue.option.xAxis[0],
              'data',
              res.data.map((item) => item.teamName)
            )
            this.$set(
              this.propValue.option.series[0],
              'data',
              res.data.map((item) => item.personCount)
            )
            this.$set(
              this.propValue.option.series[1],
              'data',
              res.data.map((item) => item.verifyCount)
            )
          } else if (this.element.componentType === 'AttendanceWokerType') {
            this.$set(
              this.propValue.option.xAxis[0],
              'data',
              res.data.map((item) => item.workerTypeName)
            )
            this.$set(
              this.propValue.option.series[0],
              'data',
              res.data.map((item) => item.personCount)
            )
            this.$set(
              this.propValue.option.series[1],
              'data',
              res.data.map((item) => item.verifyCount)
            )
          } else if (this.element.componentType === 'EnvironmentalMonitor') {
            const xData = Object.keys(res.data)
            xData.sort(function (a, b) {
              return a - b
            })
            this.$set(this.propValue.option.xAxis[0], 'data', xData)
            const tsp = []
            const pm10 = []
            const pm25 = []
            const noise = []
            const humidity = []
            const temperature = []
            const windDirection = []
            const windSpeed = []
            const windLv = []
            const barometric = []
            xData.forEach((key) => {
              const element = res.data[key]
              tsp.push(element.tsp)
              pm10.push(element.pm10)
              pm25.push(element.pm25)
              noise.push(element.noise)
              humidity.push(element.humidity)
              temperature.push(element.temperature)
              windDirection.push(element.wind)
              windSpeed.push(element.windSpeed)
              windLv.push(element.windLv)
              barometric.push(element.barometric)
            })

            this.$set(this.propValue.option.series[0], 'data', tsp)
            this.$set(this.propValue.option.series[1], 'data', pm10)
            this.$set(this.propValue.option.series[2], 'data', pm25)
            this.$set(this.propValue.option.series[3], 'data', noise)
            this.$set(this.propValue.option.series[4], 'data', humidity)
            this.$set(this.propValue.option.series[5], 'data', temperature)
            this.$set(this.propValue.option.series[6], 'data', windDirection)
            this.$set(this.propValue.option.series[7], 'data', windSpeed)
            this.$set(this.propValue.option.series[8], 'data', windLv)
            this.$set(this.propValue.option.series[9], 'data', barometric)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.VChartComponentWrap {
  width: 100%;
  height: 100%;
  position: relative;
  .rate {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    text-align: center;
    .title {
      font-size: 16px;
    }
    .rateNum {
      font-size: 26px;
    }
  }
}
</style>

